import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  isSending: PropTypes.bool.isRequired,
  onSelectItem: PropTypes.func.isRequired,
  question: PropTypes.shape({
    answers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })).isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  selectedItems: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const Question = ({ isSending, onSelectItem, question, selectedItems }) => {
  const { answers, title } = question;

  const siblingItems = answers
    .reduce((acc, curr) => [...acc, curr.id], []);

  // Find the currently selected answer for this question
  const selectedAnswer = selectedItems.find(item => 
    answers.some(answer => answer.id === item)
  ) || '';

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue) {
      // Remove any previously selected items from this question and select the new one
      onSelectItem(
        selectedValue,
        siblingItems.filter((item) => item !== selectedValue)
      );
    }
  };

  return (
    <>
      <h2 className="h2 question-title">
        {title}
      </h2>
      <div className="question-data-wrap">
        <select
          className="question-dropdown"
          disabled={isSending}
          onChange={handleSelectChange}
          value={selectedAnswer}
        >
          <option value="">Valitse vastaus...</option>
          {answers.map((answer) => (
            <option
              key={answer.id}
              value={answer.id}
            >
              {answer.title}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

Question.propTypes = propTypes;

export default Question;
